<template>
    <div class="container">
        <p class="titleMain">Личный кабинет</p>
        <form class="user-card">
            <div class="user-img">
                <label class="addPhoto" v-bind:style="{ backgroundImage: 'url(' + user.userAvatar + ')' }">
                    <input type="file" @change="handleImage" accept="image/*">
                </label>
            </div>
            <div class="user-info">
               <p>{{user.userName}} {{user.userLastName}}</p>
               <p>{{user.userPhone}}</p>
               <p>{{user.userEmail}}</p>
            </div>
            
        </form>
        <p @click="logOut" class="logout">ВЫХОД</p>
    </div>
</template>

<script>
export default {
     data: () => ({
        customImageMaxSize: 3, // megabytes
		user: {}
    }),
    methods: {
        logOut(){
            this.$store.dispatch('LOGOUT');
            this.$localStorageDelete('miniCart') //Удалить миникорзину в localStorage
            this.$localStorageDelete('currentCollection') //Удалить коллекцию в localStorage
            this.$router.push('/')
        },

        // Загрузка изображений
        handleImage(e){
			const selectedImage = e.target.files[0];
			this.createBase64Image(selectedImage);
		},
		createBase64Image(fileObject){
			let self = this;
			const render = new FileReader();

			render.onload = (e) => {
				this.userAvatar = e.target.result;
			}
            
			render.readAsDataURL(fileObject);
		}
    },
    created(){
        this.user = JSON.parse(localStorage.getItem('userInfo'));
    }
}
</script>

<style lang="scss" scoped>
    .user-card{
        padding: 10px 15px;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        display: flex;
        flex-direction: column;
        .user-img{
            width: 100px;
            height: 100px;
            margin: 0 auto;
            margin-bottom: 15px;
            .addPhoto{
                width: 100%;
                height: 100%;
                position: relative;
                border-radius: 50%;

                &::after{
                    content: '';
                    position: absolute;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background: url('../img/addPhoto.svg');
                    background-position: center;
                    background-size: contain;
                    right: 0;
                    bottom: 0;

                }
                input{
                    width: 0;
                    height: 0;
                    overflow: hidden;
                    position: absolute;
                    z-index: -999;
                }
            }
        }
        .user-info{
            max-width: calc(100% - 90px);
           margin-right: 10px;
            p{
                font-size: 14px;
                margin-bottom: 5px;
                font-weight: 600;
            }    
        }
    }
    .logout{
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        margin-top: auto;

    }
</style>